import Button from "@/components/forms/Button";
import { Link } from "wouter";

type PageNotFoundProps = { params?: unknown, resourceType?: string };

export default function PageNotFound({resourceType = "page"}: PageNotFoundProps) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        height: "100vh",
        justifyContent: "center",
      }}
    >
      <img src="/images/isometric-open-box.svg" />
      <div
        className="strong"
        style={{paddingTop: "12px"}}
      >
        <span style={{color: "var(--color-primary)"}}>404</span> – Page Not Found
      </div>
      <div style={{paddingTop: "8px"}}>Sorry! We couldn't find the {resourceType} you were looking for.</div>
      <div
        className="strong"
        style={{paddingTop: "24px"}}
      >
        <Link to="/"><Button>Go to Dashboard →</Button></Link>
      </div>
    </div>
  );
}
